module.exports = function() {
  return new Worker(__webpack_public_path__ + "f4b26748774fba558ba4.worker.js");
};